import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HeroSection } from './components/HeroSection';
import { PreQualForm } from './components/PreQualForm';
import { BenefitsSection } from './components/BenefitsSection';
import { SocialProof } from './components/SocialProof';
import { HowItWorks } from './components/HowItWorks';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { TermsOfService } from './pages/TermsOfService';
function HomePage() {
  const scrollToForm = () => {
    document.getElementById('qualify-form')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="w-full min-h-screen bg-black text-white font-sans pb-20 md:pb-0 relative" data-id="element-0">
      <HeroSection data-id="element-1" />
      <PreQualForm data-id="element-2" />
      <BenefitsSection data-id="element-3" />
      <SocialProof data-id="element-4" />
      <HowItWorks data-id="element-5" />
      <FinalCTA data-id="element-6" />
      <Footer data-id="element-7" />

      {/* Sticky Mobile CTA */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 p-4 bg-black/90 backdrop-blur-sm border-t border-gray-800 z-50" data-id="element-8">
        <button onClick={scrollToForm} className="w-full bg-gold-primary text-black font-bold text-lg py-4 rounded-lg hover:bg-gold-accent transition-all duration-300 shadow-[0_0_15px_rgba(240,185,11,0.3)]" data-id="element-9">
          Check If You Qualify in 60 Seconds →
        </button>
      </div>
    </div>;
}
export function App() {
  return <BrowserRouter data-id="element-10">
      <Routes data-id="element-11">
        <Route path="/" element={<HomePage data-id="element-13" />} data-id="element-12" />
        <Route path="/privacy" element={<PrivacyPolicy data-id="element-15" />} data-id="element-14" />
        <Route path="/terms" element={<TermsOfService data-id="element-17" />} data-id="element-16" />
      </Routes>
    </BrowserRouter>;
}